import '../styles/LoginReturningNote.css';
import React from 'react';

function RuleMark() {
  return (
    <span className="lrn-mark" aria-hidden="true">
      <svg viewBox="0 0 46 16" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1.5 11.2c6.6-1.4 12.6-2.1 18.4-2" />
        <path d="M8.4 8.2c2.6-2.5 4.6-4.4 6.2-6.4" opacity="0.7" />
        <path d="M12.6 9.1c2.8-1.2 5.2-1.9 7.4-2.1" opacity="0.7" />
        <path d="M22.4 9.6c3.2-.9 6.2-1.3 9.1-1.4" />
        <path d="M34.6 8.1c3.1-.6 5.9-.8 8.6-.7" opacity="0.75" />
        <circle cx="20.2" cy="9.3" r="1.5" fill="currentColor" stroke="none" />
      </svg>
    </span>
  );
}

function LoginReturningNote() {
  return (
    <section className="lrn-band" aria-labelledby="lrn-label">
      <div className="lrn-inner">
        <div className="lrn-opener">
          <RuleMark />
          <p className="lrn-label" id="lrn-label">
            What a session opens
          </p>
        </div>
        <p className="lrn-copy">
          Once verified, you return to your own crawl history and the email leads
          extracted from it, <span className="lrn-muted">kept for your next reading session</span>{' '}
          rather than a one-off scrape.
        </p>
      </div>
    </section>
  );
}

export default LoginReturningNote;